import { type ComponentProps, type SVGProps } from 'react'
import { twMerge } from 'tailwind-merge'
import GameIconsCrystalBars from '~icons/game-icons/crystal-bars'

export function MembershipIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 5c0 .53-.206 1.012-.543 1.37l2.624 3.28a.25.25 0 0 0 .307.068l2.65-1.326A2.004 2.004 0 0 1 21 6a2 2 0 0 1 .444 3.95l-1.804 9.623A1.75 1.75 0 0 1 17.92 21H6.08a1.75 1.75 0 0 1-1.72-1.427L2.556 9.95a2 2 0 1 1 2.406-1.558l2.65 1.326a.25.25 0 0 0 .307-.068l2.624-3.28A2 2 0 1 1 14 5Zm-2 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4Z"
      />
    </svg>
  )
}

export function CreditsIcon(props: SVGProps<SVGSVGElement>) {
  return <GameIconsCrystalBars {...props} />
}

export function TicketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
      <path d="M13 5v2" />
      <path d="M13 17v2" />
      <path d="M13 11v2" />
    </svg>
  )
}

export function MembershipIconCircled(
  props: ComponentProps<'span'> & { svgProps?: SVGProps<SVGSVGElement> },
) {
  return (
    <span
      {...props}
      className={twMerge(
        'grid grid-rows-1 grid-cols-1 place-items-center bg-gradient-purple-pink rounded-full',
        'size-[1em]',
        props.className,
      )}
    >
      <MembershipIcon
        {...props.svgProps}
        className={twMerge(
          'size-full scale-75 text-white',
          props.svgProps?.className,
        )}
      />
    </span>
  )
}

export function CreditsIconCircled(
  props: ComponentProps<'span'> & { svgProps?: SVGProps<SVGSVGElement> },
) {
  return (
    <span
      {...props}
      className={twMerge(
        'grid grid-rows-1 grid-cols-1 place-items-center bg-gradient-purple-pink rounded-full',
        'size-[1em]',
        props.className,
      )}
    >
      <CreditsIcon
        {...props.svgProps}
        className={twMerge(
          'size-full scale-75 text-white',
          props.svgProps?.className,
        )}
      />
    </span>
  )
}
